import { Box, Button, Grid, styled, useTheme } from "@mui/material";
import React, { useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
// import "./dropzone.css";
export default function Dropzone({ onDrop, accept, open, maxSize, maxFiles, file, description, clearFile }) {
	const { getRootProps, getInputProps, fileRejections, isDragActive, acceptedFiles, inputRef } = useDropzone({
		accept,
		onDrop,
		maxSize,
		maxFiles,
	});
	const { t } = useTranslation();
	const files = () => {
		return (
			<Grid item xs={12} textAlign="center">
				<img
					src={file}
					style={{
						maxWidth: "100%",
						maxHeight: "300px",
						display: "block",
						margin: "0 auto",
					}}
				/>
			</Grid>
		);
	};
	useEffect(() => {
		if (fileRejections.length > 0) {
			if (fileRejections[0].errors[0].code == "too-many-files") {
				alert("Too many files");
				console.log("Too many files");
			} else {
				alert("Some files are too large");
				console.log("Some files are too large");
			}
			console.log(fileRejections);
		}
	}, [fileRejections]);
	const theme = useTheme();

	const dropzoneStyle = {
		backgroundColor: theme.palette.primary.faded,
		padding: "20px",
		border: "3px blue dashed",
		borderColor: theme.palette.primary.main,
		textAlign: "center",
		margin: "auto",
		// width: "90%",
		borderRadius: "15px",
	};
	return (
		<div>
			{file ? (
				<Grid container marginBottom={3} justifyContent={"center"} gap={2}>
					{files()}
					<Grid item>
						<Button
							variant="outlined"
							style={{ textTransform: "capitalize" }}
							onClick={() => {
								clearFile();
							}}
						>
							{t("Clear")}
						</Button>
					</Grid>
				</Grid>
			) : (
				<Box {...getRootProps()} style={dropzoneStyle} sx={{ width: { sx: "90%", md: "70%" } }}>
					<input className="input-zone" {...getInputProps()} />
					<div className="text-center">
						{isDragActive ? (
							<p className="dropzone-content">Release to drop the files here</p>
						) : (
							<>
								<p className="dropzone-content">{description}</p>
								<p className="dropzone-content">{t("Drag and Drop Here")}</p>
								<p className="dropzone-content">{t("Upload Format")}</p>
							</>
						)}
						<Button variant="outlined" onClick={open} sx={{ textTransform: "capitalize" }}>
							{t("Click to Select Files")}
						</Button>
					</div>
				</Box>
			)}
		</div>
	);
}
